module.exports = __webpack_public_path__ + "static/img/proImg3.8cc71ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/proImg3.png
// module id = Z40/
// module chunks = 1